import '.a9{max-width:50rem;}.ssr-plugin'
import { PageLayout } from '../layout/PageLayout'
import { styled } from 'inlines'
import { ColumnsSection } from '@app/components/blocks/contentSection/ColumnsSection'
import { Title } from '@app/components/core/typography/Title'
import { Button } from '@app/components/core/button/Button'
import { Card } from '@app/components/blocks/card/Card'
import useMediaQuery from '@app/util/useMediaQuery'
import { Markdown } from '@app/components/core/markdown/Markdown'
import termsAndConditions from '@app/assets/pdfs/legal/terms-and-conditions.pdf'
import cookiePolicy from '@app/assets/pdfs/legal/cookie-policy.pdf'
import privacyPolicy from '@app/assets/pdfs/legal/privacy-policy.pdf'
import { useTranslations } from '@i18n/useLanguage'

export const Legal = () => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.legalPage

  return (
    <>
      <PageLayout gap={isMobile ? '2.5rem' : '4rem'}>
        <Title.H1 style={{ textAlign: 'center', marginBottom: 0 }}>
          {t.title}
        </Title.H1>

        <div className="a9"
        >
          <Markdown
            content={`## Onze spelregels en hoe we omgaan met jouw gegevens\n
Bij CrowdBuilding vinden we het belangrijk dat je weet waar je aan toe bent. Daarom hebben we onze algemene voorwaarden en privacyverklaring overzichtelijk voor je op een rij gezet. Hierin lees je wat je van ons mag verwachten, welke spelregels gelden op ons platform, en hoe we omgaan met jouw persoonsgegevens.‍\n
We raden je aan deze documenten goed door te lezen voordat je gebruikmaakt van ons platform. Zo weet je precies hoe we jouw gegevens beschermen, wat je rechten zijn en welke afspraken er gelden als je je aanmeldt als member of initiatiefnemer.\n
Via de onderstaande links kun je beide documenten downloaden. Heb je daarna nog vragen? Neem gerust contact met ons op via [info@crowdbuilding.com](mailto:info@crowdbuilding.com).`}
          />
        </div>

        <ColumnsSection
          columns={[
            {
              content: (
                <CardDownload
                  title={`📃 ${t.termsAndConditionsDownloadTitle}`}
                  link={termsAndConditions}
                />
              ),
            },
            {
              content: (
                <CardDownload
                  title={`🕵️ ${t.privacyPolicyDownloadTitle}`}
                  link={privacyPolicy}
                />
              ),
            },
            {
              content: (
                <CardDownload
                  title={`🍪 ${t.cookiePolicyDownloadTitle}`}
                  link={cookiePolicy}
                />
              ),
            },
          ]}
        />
      </PageLayout>
    </>
  )
}

const CardDownload = ({ title, link }: { title: string; link?: string }) => {
  const t = useTranslations().app.legalPage

  const handleClick = () => {
    if (link) {
      window.open(link, '_blank')
    }
  }

  return (
    <Card title={title} style={{ flex: 1 }}>
      <Card.Actions>
        <Button label={t.downloadButtonLabel} onClick={handleClick} />
      </Card.Actions>
    </Card>
  )
}
